import { useState, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import ProductCard from "../../components/product-card/product-card.component";
import Spinner from "../../components/spinner/spinner.component";

import {
  selectCategoriesMap,
  selectCategoriesIsLoading,
} from "../../store/categories/category.selector";

import { CategoryContainer, Title } from "./category.styles";
import { selectCurrentUser } from "../../store/user/user.selector";

const Category = () => {
  const { category } = useParams();
  const currentUser = useSelector(selectCurrentUser);
  const categoriesMap = useSelector(selectCategoriesMap);
  const isLoading = useSelector(selectCategoriesIsLoading);
  const [products, setProducts] = useState(categoriesMap[category]);

  useEffect(() => {
    setProducts(categoriesMap[category]);
  }, [category, categoriesMap]);

  return (
    <Fragment>
      <Title>{category.toUpperCase()}</Title>
      {isLoading ? (
        <Spinner />
      ) : (
        <CategoryContainer>
          {currentUser
            ? products &&
              products.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))
            : "Please login to see the products."}
        </CategoryContainer>
      )}
    </Fragment>
  );
};

export default Category;
